import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const TrashIcon = ({ color, ...rest }: { color?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="12px" height="16px" viewBox="0 0 12 16" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Sensors-Selection-+-Pressure-Sensors-Config."
          transform="translate(-1122.000000, -253.000000)"
          fill={color ?? token.colorBorder}
          fillRule="nonzero"
        >
          <g id="Group-11" transform="translate(238.000000, 196.000000)">
            <g id="Group-15" transform="translate(365.000000, 46.000000)">
              <g id="Group-13" transform="translate(519.000000, 11.000000)">
                <path
                  d="M9.80394537,15.75 L2.10136571,15.75 C1.69893778,15.75 1.36570561,15.4525452 1.3383915,15.0681152 L0.677389985,5.6817627 C0.648254932,5.25906372 0.997875569,4.90246582 1.44036419,4.90246582 L10.4649469,4.90246582 C10.9074355,4.90246582 11.2570561,5.26080322 11.2279211,5.6817627 L10.5669196,15.0681152 C10.5396055,15.4525452 10.2063733,15.75 9.80394537,15.75 Z M11.9817906,3.53347778 L0.0182094082,3.53347778 C0.00728376328,3.53347778 0,3.52651978 0,3.51608276 L0,1.51739502 C0,1.50695801 0.00728376328,1.5 0.0182094082,1.5 L11.9817906,1.5 C11.9927162,1.5 12,1.50695801 12,1.51739502 L12,3.51434326 C12,3.52478027 11.9927162,3.53347778 11.9817906,3.53347778 L11.9817906,3.53347778 Z"
                  id="Shape"
                ></path>
                <path
                  d="M8.98300765,2.25 L3.01699235,2.25 C3.00679694,2.25 3,2.24321267 3,2.23303167 L3,0.0169683258 C3,0.00678733032 3.00679694,0 3.01699235,0 L8.98300765,0 C8.99320306,0 9,0.00678733032 9,0.0169683258 L9,2.23303167 C9,2.24151584 8.99320306,2.25 8.98300765,2.25 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TrashIcon;
